import { PjRouterElement } from "@/core/components";
import { getSetting } from "@/core/settings";

/** Removes the splash screen element from the page (after router has rendered the content). */
export async function registerSplashScreen(): Promise<void> {
  const el = document.getElementById("splash-backdrop");
  if (!el) {
    return;
  }

  const router = <PjRouterElement | undefined>document.getElementsByTagName("pj-router")[0];
  if (router) {
    await router.ready;
  }

  el.animate([{ opacity: 0 }], {
    duration: getSetting("pageTransitionAnimationDuration"),
    fill: "forwards",
  }).finished.then(() => {
    el.remove();
  });
}
